module.exports = __webpack_public_path__ + "static/media/aa-shape.47f90fbd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Svgs/aa-shape.svg
// module id = 321
// module chunks = 0